import { CenterProps, Text, Center, Button } from '@chakra-ui/react';
import { FC } from 'react';

export interface DateSeparatorProps extends CenterProps {
  text: string;
  scrollToGroup: () => void;
}

export const DATE_SEPARATOR_CLASSNAME = 'date-separator';

export const DateSeparator: FC<DateSeparatorProps> = ({
  text,
  scrollToGroup,
  ...rest
}) => {
  return (
    <Center {...rest}>
      <Button
        className={DATE_SEPARATOR_CLASSNAME}
        size="auto"
        borderRadius={4}
        bg="M.30"
        px={4}
        py={2}
        onClick={scrollToGroup}
        data-testid="message-group-button"
      >
        <Text color="textSubdued" fontWeight={500} fontSize="xxs">
          {text}
        </Text>
      </Button>
    </Center>
  );
};
